import { Link } from "react-router-dom";

import { routes } from "@/common/utils/routes";
import BROKEN_IMAGE from "@/common/images/icons/image_icon.svg";
import { INiche } from "@/common/services/types";

import { Image } from "@/components/UI/Image";

import "./NichePreviewImages.scss";
import { useSfw } from "@/common/hooks/useSfw";

interface IProps {
  niche: INiche;
  withPreview?: boolean;
  onPreviewClick?: () => void;
}

export const NichePreviewImages = (props: IProps) => {
  const { withPreview, onPreviewClick } = props;

  const { sanitizeNiche, isLoading } = useSfw();

  const niche = sanitizeNiche(props.niche);

  if (isLoading || !withPreview || !niche.previews) {
    return null;
  }

  return (
    <div className="NichePreviewImages">
      {
        niche.previews.slice(0, 3).map((item, index) => (
          <Link key={index} to={routes.niche(niche.id)} onClick={onPreviewClick} aria-label={`Link to ${niche.id}`}>
            <Image src={item.thumbnail ?? BROKEN_IMAGE} alt={`Preview for ${niche.id}`} />
          </Link>
        ))
      }
    </div>
  );
};
